(function ($) {
    $(() => {
        // Params

        if ($('.template--history').length) {


            $('.js-slide-navigation').on('click', function (e) {
                e.preventDefault();
                var cid = $(this).attr('href');
                var titleElement = $(`${cid}`).find('.js-description-title');
                $('.js-slide-navigation.active').removeClass('active');
                $(this).addClass('active');
                $('.js-slider.active').removeClass('active');
                $(`${cid}`).addClass('active');


                TweenLite.fromTo(titleElement, 0.5,
                    {
                        autoAlpha: 0,
                        y: -20
                    },
                    {
                        autoAlpha: 1,
                        y: 0,
                        ease: 'Expo.easeIn',
                    }
                );


            });


            var navSliders = [];
            var madinSliders = [];
            $('.js-slider').each(function (i, e) {


                var navSwiper = new Swiper(`.js-slider-${i} .nav-slider`, {
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    freeMode: false,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    observer: true,
                    observeParents: true,
                    on: {
                        imagesReady: function () {
                            this.el.classList.remove('loading');
                        },

                    }
                });

                navSliders.push(navSwiper);

                var mainSwiper = new Swiper(`.js-slider-${i} .main-slider`, {
                    spaceBetween: 0,
                    speed: 1000,
                    thumbs: {
                        swiper: navSliders[i],
                    },
                    grabCursor: true,
                    watchSlidesProgress: true,
                    observer: true,
                    observeParents: true,
                    on: {
                        imagesReady: function () {
                            this.el.classList.remove('loading');
                        },


                    }
                });

                madinSliders.push(mainSwiper);
            });
        }
    });
})(jQuery);